<template>
  <div>
    <TSLoading
      :active="isLoading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process the data...'"
    />
    <div style="height: 400px">
      <el-row type="flex" :gutter="20">
        <el-col :xl="17" :lg="17" :md="17" :xs="17" :sm="17">
          <div class="img-container">
            <img ref="image" :src="src" />
          </div>
        </el-col>
        <el-col :xl="6" :lg="6" :md="6" :xs="6" :sm="17">
          <el-row style="margin-bottom: 5px" type="flex" justify="center">
            <el-col>
              <img :src="destination" class="img-preview" />
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-col style="text-align: center">
              <p>Preview</p>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 10px" type="flex" justify="center">
            <el-col>
              <button
                class="ts-btn ts-btn-rounded ts-btn-secondary cropper-btn-save"
                @click="uploadImage"
              >
                Save
              </button>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-col>
              <button
                class="ts-btn ts-btn-rounded ts-btn-secondary cropper-btn-cancel"
                @click="onCloseDialog()"
              >
                Cancel
              </button>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import TSLoading from "../../../components/TSLoading.vue";
import Cropper from "cropperjs";
import { dataURItoBlob } from "@/utils";

export default {
  components: {
    TSLoading
  },
  name: "ImageCropper",
  props: {
    src: String,
    bucketType: Number,
    objectId: String
  },
  methods: {
    async uploadImage() {
      this.isLoading = true;
      this.b64Img.base64Raw = this.destination;
      this.$emit("imageUploading", this.b64Img);
      this.$store
        .dispatch("common/uploadImage", {
          file: await dataURItoBlob(this.destination),
          objectId: this.objectId,
          bucketType: this.bucketType,
          fileExtension: "png"
        })
        .then(() => {
          this.isLoading = false;
          this.$message.success("Upload Successful!");
        })
        .catch(() => {
          this.isLoading = false;
          this.$message.error();
          ("Something went wrong please try again later.");
        });
    },
    onCloseDialog() {
      this.$emit("onCloseDialog");
    }
  },
  data() {
    return {
      isLoading: false,
      cropper: {},
      destination: {},
      image: {},
      b64Img: {},
      interval: {}
    };
  },
  mounted() {
    this.image = this.$refs.image;
    this.cropper = new Cropper(this.image, {
      zoomable: false,
      aspectRatio: 1,
      crop: () => {
        const canvas = this.cropper.getCroppedCanvas();
        this.destination = canvas.toDataURL("image/png");
      }
    });
  }
};
</script>

<style scoped>
.img-container {
  height: 400px;
  width: 500px;
  float: left;
}
.img-preview {
  height: 200px;
  width: 200px;
  float: left;
  margin-left: 10px;
}
.cropper-btn-save {
  margin-top: 25px;
  margin-left: 50px;
  width: 130px;
  float: left;
}
.cropper-btn-cancel {
  margin-left: 50px;
  margin-top: 5px;
  width: 130px;
  float: left;
}
</style>
